module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/vertical-kv-list/vertical-kv-list.component.scss
// module id = ./src/app/modules/common-module/components/vertical-kv-list/vertical-kv-list.component.scss
// module chunks = 9